export const HigieneYCuidados = () => {
    return (
        <div className='educative-info-section'>
            <div className='educative-container'>
                <header className='educative-header'>
                    <h1 className='educative-main-title'>Higiene y cuidados durante tu periodo</h1>
                    <p className='educative-subtitle'>Pasos sencillos para sentirte cómoda y mantener tu salud</p>
                </header>

                <div className='educative-text-box-container educative-info-textarea' style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                    <section>
                        <p>
                            Cuando tienes tu periodo (menstruación), es importante que cuides tu cuerpo para sentirte cómoda y mantenerte saludable.
                            Esto se llama higiene menstrual y aquí te explicamos cómo hacerlo de forma sencilla.
                        </p>
                    </section>

                    <section>
                        <h3>¿Qué productos puedes usar?</h3>
                        <p>Hay diferentes opciones para recoger la sangre menstrual. Elige la que te haga sentir más segura y cómoda:</p>
                        <ul>
                            <li><strong>Toallas higiénicas:</strong> Son fáciles de usar y se pegan a tu ropa interior. Hay de distintos tamaños y formas.</li>
                            <li><strong>Ropa interior absorbente:</strong> Es como una calza especial que absorbe la sangre. Se puede lavar y volver a usar.</li>
                        </ul>
                    </section>

                    <section>
                        <h3>¿Cómo mantenerte limpia?</h3>
                        <ul>
                            <li>Cambia tu toalla o ropa interior cada 4 a 6 horas, o cuando sientas que está húmeda.</li>
                            <li>Lávate las manos antes y después de cambiarte.</li>
                            <li>Limpia tu zona íntima con agua tibia; no necesitas usar jabones especiales.</li>
                            <li>Usa ropa cómoda y limpia durante esos días.</li>
                        </ul>
                    </section>

                    <section>
                        <h3>Consejos útiles</h3>
                        <ul>
                            <li>Lleva siempre una toalla higiénica extra en tu mochila.</li>
                            <li>Lleva una ropa interior extra.</li>
                            <li>Si te manchas, no te preocupes. A todas nos ha pasado. Puedes cambiarte y seguir tu día con normalidad.</li>
                            <li>Si quieres sentirte más segura, puedes usar una calza corta.</li>
                            <li>Habla con una persona de confianza si tienes dudas o te sientes incómoda.</li>
                        </ul>
                    </section>
                </div>
            </div>
        </div>
    );
};
